
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("4yqs9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ae5a0ffd4498a765$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $ae5a0ffd4498a765$export$2e2bcd8739ae039 = {
    'fabric.atlassianSwitcher.administration': "Administra\xe7\xe3o",
    'fabric.atlassianSwitcher.analytics': "Dados de an\xe1lise",
    'fabric.atlassianSwitcher.assets': 'Recursos',
    'fabric.atlassianSwitcher.atlassianHome': "P\xe1gina inicial",
    'fabric.atlassianSwitcher.atlassianWebsiteTryProducts': 'Experimente os produtos da Atlassian',
    'fabric.atlassianSwitcher.autoProvConfluenceUiUpdateExperimentDescription': "Colabora\xe7\xe3o de documentos",
    'fabric.atlassianSwitcher.chat': 'Bate-papo',
    'fabric.atlassianSwitcher.companyHub': 'Hub da empresa',
    'fabric.atlassianSwitcher.confluenceDescriptionText': 'Documente e colabore',
    'fabric.atlassianSwitcher.confluenceSpace': "Espa\xe7o do Confluence",
    'fabric.atlassianSwitcher.emptyState.exploreProducts.body': "Teste um produto para come\xe7ar a colaborar com a equipe.",
    'fabric.atlassianSwitcher.emptyState.exploreProducts.link': "Conhe\xe7a os produtos",
    'fabric.atlassianSwitcher.emptyState.exploreProducts.title': 'Comece a usar a nuvem',
    'fabric.atlassianSwitcher.errorEmptyPartialResults': "N\xe3o \xe9 poss\xedvel exibir os apps agora.",
    'fabric.atlassianSwitcher.errorFlag.description': "Tente outra vez em alguns minutos. Se ainda n\xe3o for poss\xedvel entrar, <a>entre em contato com o suporte</a>.",
    'fabric.atlassianSwitcher.errorFlag.title': "N\xe3o foi poss\xedvel adicionar voc\xea ao {product}",
    'fabric.atlassianSwitcher.errorHeading': 'Algo deu errado',
    'fabric.atlassianSwitcher.errorHeadingLoggedOut': "Voc\xea saiu da conta da Atlassian",
    'fabric.atlassianSwitcher.errorHeadingUnverified': "Esta conta n\xe3o foi verificada",
    'fabric.atlassianSwitcher.errorImageAltText': "Um rob\xf4 quebrado e v\xe1rias pessoas ocupadas no conserto dele.",
    'fabric.atlassianSwitcher.errorPartialResults': "N\xe3o \xe9 poss\xedvel exibir alguns apps agora.",
    'fabric.atlassianSwitcher.errorPartialResultsRefresh': "Atualize a p\xe1gina ou tente de novo mais tarde.",
    'fabric.atlassianSwitcher.errorText': "N\xf3s acompanhamos esses erros, mas fique \xe0 vontade para entrar em contato conosco caso a atualiza\xe7\xe3o n\xe3o resolva as coisas",
    'fabric.atlassianSwitcher.errorTextLoggedOut': 'Entre de novo para usar o Atlassian Switcher.',
    'fabric.atlassianSwitcher.errorTextNetwork': "N\xe3o foi poss\xedvel carregar esta lista. Recarregue a p\xe1gina e tente novamente.",
    'fabric.atlassianSwitcher.errorTextUnverified': "Confirme o endere\xe7o de e-mail para ver uma lista de produtos dispon\xedveis.",
    'fabric.atlassianSwitcher.goals': 'Metas',
    'fabric.atlassianSwitcher.home': 'Atlassian Home',
    'fabric.atlassianSwitcher.instantAccessStatusText': "Acesso instant\xe2neo",
    'fabric.atlassianSwitcher.jiraDescriptionText': 'Planeje e acompanhe a entrega do projeto',
    'fabric.atlassianSwitcher.jiraProject': 'Projeto do Jira',
    'fabric.atlassianSwitcher.join': 'Entrar',
    'fabric.atlassianSwitcher.joinStatusText': 'Entrar',
    'fabric.atlassianSwitcher.joinTeamStatusText': "Fa\xe7a parte da equipe",
    'fabric.atlassianSwitcher.jpdDescriptionText': 'Priorize e planeje novas ideias',
    'fabric.atlassianSwitcher.jsmDescriptionText': "Automatize e ofere\xe7a suporte de TI",
    'fabric.atlassianSwitcher.jwmInactiveSwitcherWithDefaultItemDescription': 'Gerencie projetos para equipes empresariais',
    'fabric.atlassianSwitcher.jwmInactiveSwitcherWithJSWItemDescription': 'Gerencie projetos empresariais sem custos com o Jira Software',
    'fabric.atlassianSwitcher.login': 'Entrar',
    'fabric.atlassianSwitcher.manageList': 'Gerenciar lista',
    'fabric.atlassianSwitcher.modalLabel': 'Gerenciador de Aplicativos da Atlassian',
    'fabric.atlassianSwitcher.more': 'Mais',
    'fabric.atlassianSwitcher.newLozenge': 'Novo',
    'fabric.atlassianSwitcher.organisationsLabel': "Organiza\xe7\xf5es",
    'fabric.atlassianSwitcher.product.description.compass': 'Gerenciador de componentes',
    'fabric.atlassianSwitcher.product.description.confluence': "Colabora\xe7\xe3o de documentos",
    'fabric.atlassianSwitcher.product.description.jsm': "Gerenciamento de servi\xe7o de TI colaborativo",
    'fabric.atlassianSwitcher.product.description.jsw': 'Monitoramento de projetos e itens',
    'fabric.atlassianSwitcher.product.description.opsgenie': 'Gerenciamento de incidentes moderno',
    'fabric.atlassianSwitcher.requestAccessStatusText': 'Solicitar acesso',
    'fabric.atlassianSwitcher.requestSentStatusText': "Solicita\xe7\xe3o enviada",
    'fabric.atlassianSwitcher.resizeBarLabel': '"Expandir" ou "Recolher", dependendo do estado',
    'fabric.atlassianSwitcher.resizeBarTooltipCollapsed': 'Arraste para redimensionar{separator}Pressione para expandir',
    'fabric.atlassianSwitcher.resizeBarTooltipExpanded': 'Arraste para redimensionar{separator}Pressione para recolher',
    'fabric.atlassianSwitcher.resizeBarValueTextLabel': 'Largura',
    'fabric.atlassianSwitcher.search': 'Pesquisar',
    'fabric.atlassianSwitcher.sites': '{numSites, plural, one {{productName} site} other {{productName} sites}}',
    'fabric.atlassianSwitcher.skeletonLoaderAriaLabel': "O Gerenciador de Aplicativos est\xe1 carregando",
    'fabric.atlassianSwitcher.start': "P\xe1gina inicial da Atlassian",
    'fabric.atlassianSwitcher.startAriaLabel': "A p\xe1gina inicial da Atlassian vai abrir em uma nova guia",
    'fabric.atlassianSwitcher.studio': "Est\xfadio",
    'fabric.atlassianSwitcher.successFlag.description': "Voc\xea vai receber um e-mail quando a solicita\xe7\xe3o for aprovada",
    'fabric.atlassianSwitcher.successFlag.title': "Solicita\xe7\xe3o de acesso enviada ao administrador",
    'fabric.atlassianSwitcher.switchSitesOrAppsTooltip': 'Trocar sites ou aplicativos',
    'fabric.atlassianSwitcher.switchTo': 'Alternar para',
    'fabric.atlassianSwitcher.switchToTooltip': "Alternar para\u2026",
    'fabric.atlassianSwitcher.teams': 'Equipes',
    'fabric.atlassianSwitcher.tryLozenge': 'Testar',
    'fabric.atlassianSwitcher.yourApps': 'Seus aplicativos',
    'fabric.atlassianSwitcher.yourAppsTooltip': "Seus aplicativos\u2026"
};

});


//# sourceMappingURL=@atlaskit-internal_async-atlassian-switcher-i18n-pt-BR.d57cd0e1.js.map
